import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReAuth from "src/business.InterfaceLayer/store/services/utils.service/baseQueryWithReAuth";
import { ProfilePassportModalType } from "src/old/Types/ProfileEditType";
import {
	RequestResponse,
	RequestResponseFreedom,
	ServerResponse,
} from "./types/types";
import { formatToISO } from "src/business.InterfaceLayer/store/services/formatToISO";

export const profilePassportApi = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: "profilePassportApi",
	endpoints: (builder) => ({
		getProfilePassportDepartment: builder.query<RequestResponseFreedom, string>(
			{
				query: (code) => ({
					url: `/location/departments/${code}`,
					method: "GET",
				}),
				transformResponse: (
					response: ServerResponse
				): RequestResponseFreedom => {
					//console.log("getProfilePassportDepartment server otvet", response);
					return {
						isErr: undefined,
						data: (response as any) || undefined,
					};
				},
			}
		),
		///////////////////////////////////////////////////////////////////////////POST
		postProfilePassport: builder.mutation<
			RequestResponse,
			ProfilePassportModalType
		>({
			query: (data) => {
				const userId = localStorage.getItem("userId") || "";
				if (!userId) {
					throw new Error("User ID is not found in localStorage");
				}

				const payload = {
					dateBirth: formatToISO(data.dateBirth),
					passportSeries: data.passportSeries,
					passportNumber: data.passportNumber,
					passportDateIssue: formatToISO(data.passportDateIssue),
					passportIssued: data.passportIssued,
					passportIssuerCode: data.passportIssuerCode,
					snils: data.snils,
				};

				//console.log("payloadPassport:", payload);

				return {
					url: `/v2/user/${userId}/profile/passport`,
					method: "PUT",
					body: JSON.stringify(payload),
					headers: {
						"Content-Type": "application/json",
					},
				};
			},
			transformResponse: (response: ServerResponse): RequestResponse => ({
				isErr: undefined,
				data: response.data || undefined,
			}),
		}),
	}),
});

export const {
	useLazyGetProfilePassportDepartmentQuery,
	usePostProfilePassportMutation,
} = profilePassportApi;
